import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Id from 'models/id';
import { Trans } from 'react-i18next';
import 'scss/Main.scss';
import ClientBlocksModal from './ClientBlocks/ClientBlocksModal';

type ClientBlocksBtnProps = Id & {
    isOpen?: boolean;
    toggle: (item: string) => void;
};

export default function ClientBlocksBtn({ id, isOpen = false, toggle }: ClientBlocksBtnProps) {
    return (
        <>
            <div
                className="workplace-action-btn cursor--pointer"
                onClick={() => {
                    toggle(id?.toString() || '');
                }}
            >
                <FontAwesomeIcon
                    icon={faLock}
                    className="text-warning workplace-action-btn__icon"
                />
                <span>
                    <Trans i18nKey="BackOfficeClientBlocks" />
                </span>
            </div>
            <ClientBlocksModal id={id} toggle={toggle} isOpen={isOpen} />
        </>
    );
}
